import {
  DocumentData,
  DocumentReference,
  INamedDocument,
  WithPrimaryKey,
} from '@principle-theorem/shared';

export interface IHasSourceIdentifier {
  sourceIdentifier: string;
}

export interface ISourceLinkOption {
  sourceIdentifier: string;
  sourceLabel: string;
  resourceType: string;
}

export interface ITranslationMap<T extends object = object, R = unknown> {
  id?: string;
  sourceIdentifier: string;
  sourceLabel?: string;
  sourceLink?: ISourceLinkOption;
  resourceType: string;
  destinationValue?: { value: R };
  destinationIdentifier?: DocumentReference<T>;
  associatedValue?: string | INamedDocument<T>;
  isManualInput?: boolean;
}

export interface ITranslationMapHandler {
  upsert(translationMap: ITranslationMap): Promise<void>;
  getByType<T extends object = object, R = unknown>(
    resourceType: string
  ): Promise<WithPrimaryKey<ITranslationMap<T, R>>[]>;
  getDestination<T extends object = object>(
    sourceIdentifier: string,
    resourceType: string
  ): Promise<DocumentReference<T> | undefined>;
  getBySource<T extends object = object, R = unknown>(
    sourceIdentifier: string,
    resourceType: string
  ): Promise<WithPrimaryKey<ITranslationMap<T, R>> | undefined>;
  getByDestination<T extends object = DocumentData, R = unknown>(
    destinationIdentifier: DocumentReference<T>,
    resourceType: string
  ): Promise<WithPrimaryKey<ITranslationMap<T, R>> | undefined>;
}
